import { render } from "./NotFound.vue?vue&type=template&id=3025624e&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=3025624e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3025624e"]])

export default __exports__